import { useEffect } from 'react'

import { PageWrapper } from '@/Shared/ui/layout'

export const CheckStatusOpenPage = (): JSX.Element => {
  useEffect(() => {
    window.parent.postMessage('firm_process_completed',  import.meta.env.VITE_SITE )
  }, [])

  return (
    <PageWrapper paddingSmaller>
      <></>
    </PageWrapper>
  )
}
